module.exports = __webpack_public_path__ + "static/media/bg-word-active.22baefc7.png";